import { createFileRoute } from '@tanstack/react-router';

import { SystemBrandDefaultsView } from 'src/sections/admin/system-brand-defaults/system-brand-defaults-view';

export const Route = createFileRoute('/admin-skidog/system-brand-defaults')({
  component: SystemBrandDefaultsView,
});
